import type { SVGProps } from 'react';

const SvgDevApi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M7 16c-.26 0-.51-.1-.71-.29l-3-3a.996.996 0 0 1 0-1.41l3-3A.996.996 0 1 1 7.7 9.71L5.41 12l2.29 2.29a.996.996 0 0 1-.71 1.7zm10 0c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.29-2.29-2.29-2.29a.996.996 0 1 1 1.41-1.41l3 3c.39.39.39 1.02 0 1.41l-3 3c-.2.2-.45.29-.71.29zm-6 2c-.06 0-.13 0-.2-.02-.54-.11-.89-.64-.78-1.18l2-10c.11-.54.63-.89 1.18-.78.54.11.89.64.78 1.18l-2 10c-.09.48-.51.8-.98.8"
    />
  </svg>
);
export default SvgDevApi;
